import { useTranslation } from "react-i18next";
import { getStoreType, languageSelection } from "../../../../dynamicController";

const STORETYPE = getStoreType()

const SettingDetails = ({
  selected,
  handleBack,
  handleChange,
  handleLang,
  handleSubmit,
  name,
  email /* , oldPassword*/,
  number,
  otp,
  showOtp,
  newPassword,
  language,
  loading,
  birthdayDate,
  handleBirthday,
  einvoice_id_type,
  einvoice_id_value,
  address,
  city,
  postcode,
  state,
  country,
  nationality,
  gender,
  race,
  salutation,
}) => {
  const { t } = useTranslation();

  const renderPage = () => {
    if (selected === "name") {
      return (
        <form id="name-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {STORETYPE !== "cleanpro" ? <label htmlFor="name">{t("Name")}</label> : null}
            <input
              type="text"
              id="name"
              name="name"
              placeholder={t("Name")}
              value={name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mt-5">
            <input
              id="change-name"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update name") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "email") {
      return (
        <form id="email-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {STORETYPE !== "cleanpro" ? <label htmlFor="email">{t("Email")}</label> : null}
            <input
              type="email"
              id="email"
              name="email"
              placeholder={t("Email")}
              value={email}
              onChange={handleChange}
              required
            />
          </div>

          {
            showOtp ? (
              <div>
                {STORETYPE !== "cleanpro" ? <label htmlFor="otp">{t("OTP")}</label> : null}
                <input
                  type="number"
                  id="otp"
                  name="otp"
                  placeholder={t("OTP")}
                  value={otp}
                  onChange={handleChange}
                  required
                />
                <small>{t("Our One-Time Password (OTP) emails might end up in your spam or junk folder. We kindly ask you to take a moment to check your spam mailbox.")}</small>
              </div>
            ) : null
          }

          <div className="mt-5">
            <input
              id="change-email"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update email address") : t("Verify")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "number") {
      return (
        <form id="number-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {STORETYPE !== "cleanpro" ? <label htmlFor="number">{t("Phone Number")}</label> : null}
            <input
              type="number"
              id="number"
              name="number"
              placeholder={t("Phone Number")}
              value={number}
              onChange={handleChange}
              required
            />
          </div>

          {
            showOtp ? (
              <div>
                {STORETYPE !== "cleanpro" ? <label htmlFor="otp">{t("OTP")}</label> : null}
                <input
                  type="number"
                  id="otp"
                  name="otp"
                  placeholder={t("OTP")}
                  value={otp}
                  onChange={handleChange}
                  required
                />
              </div>
            ) : null
          }

          <div className="mt-5">
            <input
              id="change-phone-number"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update phone number") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "password") {
      return (
        <form id="password-form" onSubmit={handleSubmit}>
          {/* <div className="form-group">
                        <label htmlFor="oldPassword">Old Password</label>
                        <input type="text" id="oldPassword" name="oldPassword" placeholder="" value={oldPassword} onChange={handleChange} required />
                    </div> */}

          <div className="form-group">
            {STORETYPE !== "cleanpro" ? <label htmlFor="newPassword">{t("New Password")}</label> : null}
            <input
              type="text"
              id="newPassword"
              name="newPassword"
              placeholder={t("New Password")}
              value={newPassword}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mt-5">
            {loading ? (
              <div className="text-center">
                <div
                  className={STORETYPE === "cuci" ? "spinner-border text-warning" : "spinner-border text-primary"}
                  role="status"
                >
                  <span className="sr-only">Loading ...</span>
                </div>
              </div>
            ) : (
              <input
                id="change-password"
                type="submit"
                style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
                value={STORETYPE === "cleanpro" ? t("Change password") : t("SUBMIT")}
                className="btn big-button form-control"
              />
            )}
          </div>
        </form>
      );
    } else if (selected === "language") {
      return (
        <form id="language-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {STORETYPE !== "cleanpro" ? (
              <>
                <label htmlFor="language">{t("Language")}</label>
                <select
                  name="language"
                  id="language"
                  className="browser-default form-select"
                  value={language}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    {t("Select language")}
                  </option>
                  {
                    languageSelection.map((language, index) => {
                      return (
                        <option value={language.value} key={index}>{language.title}</option>
                      )
                    })
                  }
                </select>
              </>
            ) : (
              <>
                {
                  languageSelection.map((lang, index) => {
                    return (
                      <input
                        key={index}
                        onClick={handleLang}
                        id="language"
                        name={lang.value}
                        type="button"
                        value={lang.title}
                        className={`d-block full-width my-3 btn big-button ${language === lang.value ? "highlight-btn" : "lowlight-btn"}`}
                      />
                    )
                  })
                }
              </>
            )}
          </div>

          <div className="mt-5">
            <input
              id="change-language"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Change language") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "birthday") {
      return (
        <form id="birthday-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="date"
              id="birthdayDate"
              name="birthdayDate"
              placeholder={t("Select your birth date")}
              value={birthdayDate}
              onChange={handleBirthday}
              required
            />
          </div>

          <div className="mt-5">
            <input
              id="update-birthday"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update date of birth") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      )
    } else if (selected === "salutation") {
      return (
        <form id="profile-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {STORETYPE !== "cleanpro" ? <label htmlFor="salutation">{t("Salutation")}</label> : null}
            <input
              type="text"
              id="salutation"
              name="salutation"
              placeholder={t("Salutation")}
              value={salutation}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mt-5">
            <input
              id="change-salutation"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update salutation") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "idType") {
      return (
        <form id="profile-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="einvoice_id_type">{t("ID Type")}</label>
            <select
              name="einvoice_id_type"
              id="einvoice_id_type"
              className="browser-default form-select"
              value={einvoice_id_type}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                {t("Select ID Type")}
              </option>
              <option value="NRIC">NRIC</option>
              <option value="PASSPORT">PASSPORT</option>
              <option value="ARMY">ARMY</option>
              <option value="BRN">BRN</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="einvoice_id_value">{t("ID Value")}</label>
            <input
              type="text"
              id="einvoice_id_value"
              name="einvoice_id_value"
              placeholder={einvoice_id_type ? t(einvoice_id_type) : t("ID Value")}
              value={einvoice_id_value}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mt-5">
            <input
              id="change-idType"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update ID Type") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "address") {
      return (
        <form id="profile-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="address">{t("Address")}</label>
            <input
              type="text"
              id="address"
              name="address"
              placeholder={t("Address")}
              value={address}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="city">{t("City")}</label>
            <input
              type="text"
              id="city"
              name="city"
              placeholder={t("City")}
              value={city}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="postcode">{t("Postcode")}</label>
            <input
              type="text"
              id="postcode"
              name="postcode"
              placeholder={t("Postcode")}
              value={postcode}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="state">{t("State")}</label>
            <input
              type="text"
              id="state"
              name="state"
              placeholder={t("State")}
              value={state}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="country">{t("Country")}</label>
            <input
              type="text"
              id="country"
              name="country"
              placeholder={t("Country")}
              value={country}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mt-5">
            <input
              id="change-address"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update Address") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "nationality") {
      return (
        <form id="profile-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {STORETYPE !== "cleanpro" ? <label htmlFor="nationality">{t("Nationality")}</label> : null}
            <input
              type="text"
              id="nationality"
              name="nationality"
              placeholder={t("Nationality")}
              value={nationality}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mt-5">
            <input
              id="change-nationality"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update nationality") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "gender") {
      return (
        <form id="profile-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {STORETYPE !== "cleanpro" ? <label htmlFor="gender">{t("Gender")}</label> : null}
            <select
              id="gender"
              name="gender"
              className="browser-default form-select"
              placeholder={t("Gender")}
              value={gender}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                {t("Select gender")}
              </option>
              <option value="Male">{t("Male")}</option>
              <option value="Female">{t("Female")}</option>
            </select>
          </div>

          <div className="mt-5">
            <input
              id="change-gender"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update gender") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    } else if (selected === "race") {
      return (
        <form id="profile-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {STORETYPE !== "cleanpro" ? <label htmlFor="race">{t("Race")}</label> : null}
            <input
              type="text"
              id="race"
              name="race"
              placeholder={t("Race")}
              value={race}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mt-5">
            <input
              id="change-race"
              type="submit"
              style={{ textTransform: STORETYPE === "cleanpro" && "none" }}
              value={STORETYPE === "cleanpro" ? t("Update race") : t("SUBMIT")}
              className="btn big-button form-control"
            />
          </div>
        </form>
      );
    }
  };

  return (
    <div className="m-0 p-0">
      <div id="user-header">
        <h5>
          <i
            onClick={(e) => handleBack()}
            className="bi bi-chevron-left me-3"
          ></i>
          <strong>
            {
              STORETYPE === "cleanpro" ?
                selected === "name" ? t("Update name") :
                  selected === "number" ? t("Update phone number") :
                    selected === "email" ? t("Update email address") :
                      selected === "password" ? t("Change password") :
                        selected === "language" ? t("Change language") :
                          selected === "birthday" ? t("Update birth date") :
                            selected === "salutation" ? t("Update salutation") :
                              selected === "idType" ? t("Update ID Type") :
                                selected === "address" ? t("Update Address") :
                                  selected === "nationality" ? t("Update nationality") :
                                    selected === "gender" ? t("Update gender") :
                                      selected === "race" ? t("Update race") : ""
                : t("Back")
            }
          </strong>
        </h5>
      </div>

      <div className="p-5">{renderPage()}</div>
    </div>
  );
};

export default SettingDetails;
